(() => {
  if (!document.querySelector('[data-va-offer-activate]')) return;
  let applying = false;
  const showSuccess = () => {
    document.querySelector('.va-offer-toast')?.remove();
    const message = document.createElement('div');
    message.className = 'va-offer-toast';
    message.setAttribute('role', 'status');
    message.textContent = document.documentElement.dataset.vaOfferSuccess || 'VANILLE15';
    document.body.append(message);
    window.setTimeout(() => message.remove(), 5000);
    document.querySelectorAll('[data-va-offer-activate]').forEach(link => {
      link.textContent = link.dataset.vaOfferApplied || 'VANILLE15';
      link.removeAttribute('aria-busy');
    });
  };
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-va-offer-activate]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (applying) return;
    applying = true;
    link.setAttribute('aria-busy', 'true');
    const destination = link.dataset.vaOfferRedirect
      ? new URL(link.dataset.vaOfferRedirect, location.origin)
      : new URL(location.href);
    link.href = '/discount/VANILLE15?redirect=' + encodeURIComponent(destination.pathname + destination.search + destination.hash);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: 'VANILLE15' })
      });
      if (!response.ok) throw new Error('Discount activation failed');
      const cart = await response.json();
      const codes = cart.discount_codes || [];
      const rejected = codes.find(code => code.code === 'VANILLE15' && code.applicable === false);
      if (cart.item_count > 0 && rejected) throw new Error('Discount not applicable');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'va-promotion', cartData: cart });
      }
      showSuccess();
      if (location.pathname.endsWith('/cart')) location.reload();
    } catch (_) {
      location.assign(link.href);
    } finally {
      applying = false;
      link.removeAttribute('aria-busy');
    }
  }, true);
})();
